// -- todo - base service class
import { RestClient } from "./restClient";

export class BerthService {
	constructor(options) {
		this._options = options;
		this._restClient = new RestClient();
	}

	getAllBerths(callback) {
		const url = "/berth-schedule-app/api/berths";
		this._restClient.exec_get(url, callback);
	}
}
